
import Vue from 'vue'
import Component from 'vue-class-component'
import { Applications } from "@/types/application/applications"
import { State } from "vuex-class"

@Component({})
export default class Toolbar extends Vue {
  @State((state: any) => state.application, { namespace: 'global' })
  private app!: string;

  private apps = Applications
  get userLoggedIn () {
    return this.$store.getters["account/user"]
  }

  private exitApplication () {
    this.$store.dispatch('global/setApplication', Applications.LINDENBERG)
    if (this.$route.name !== 'home') {
      this.$router.push({ name: 'home' })
    }
  }

  private goHome () {
    if (this.app === this.apps.LINDENBERG) {
      if (this.$route.name !== 'home') {
        this.$router.push({ name: 'home' })
      }
    } else {
      if (this.$route.name !== this.app) {
        this.$router.push({ name: this.app })
      }
    }
  }

  private get extended () {
    const timetrackRegex = new RegExp(/\/timetrack\.*\S.*/)
    return timetrackRegex.test(this.$route.path) && this.$vuetify.breakpoint.mobile
  }
}
